import { Routes } from '@angular/router';
import { LoginComponent } from './login/login/login.component';
import { PageHomeComponent } from './page-home/page-home.component';
import { CustomerService } from './Common/services/customer.service';
import { Registro } from './registro/registro';  
import { inject } from '@angular/core';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'registro', component: Registro },
    // { path: 'home', component: PageHomeComponent },
    { path: 'home', component: PageHomeComponent, 
              canActivate: [() => inject(CustomerService).canActivate()] 
    }

];
